<template>
  <div v-show="isMounted" class="flex flex-col">
    <div v-if="hasManySections" class="flex">
      <div class="flex-none" :style="{'width': firstEndCap }" />
      <div class="flex-auto border-l border-r border-black">
        <div class="flex mb-4">
          <div class="arrow-left">&nbsp;</div>
          <div class="flex-auto mt-2 border-t border-black">&nbsp;</div>
          <div class="flex-none px-2">{{ feet }} feet / {{ total }} meters</div>
          <div class="flex-auto mt-2 border-t border-black">&nbsp;</div>
          <div class="arrow-right">&nbsp;</div>
        </div>
        <!-- length -->
      </div>
      <div class="flex-none" :style="{'width': lastEndCap }" />
      <!-- Flow -->
    </div>

    <div class="items-stretch sm:flex">
      <v-section
        v-for="(section, i) in run.sections"
        :key="i"
        :ref="`section_${i}`"
        :is-mounted="isMounted"
        :plain-view="plainView"
        :run="run.id"
        :part="part"
        :parts="section"
        :depths="depths"
        :section="i"
        :outlet="run.outlet"
        :outlets="outlets"
        :to-right-flow="toRightFlow(i)"
        :first-endcap="! hasManySections ? firstEndCap : i == 1 ? firstEndCap : ''"
        :last-endcap="! hasManySections ? lastEndCap : i == 2 ? lastEndCap : ''"
        :style="{ '--width' : setWidth(section) }"
        class="drawing-section"
        @input="$emit('input', $event)"
      />
    </div>
    <p v-if="run.sections.length < 1" class="text-xl text-center">Please reload or edit this Custom Run.</p>
  </div>
</template>

<script>

import VSection from './Section'

export default {
  components: { VSection },
  props: {
    isMounted: Boolean,
    plainView: Boolean,
    run      : Object,
    part     : Object,
    outlets  : Object,
  },
  emits: ['input'],
  computed:{
    hasManySections() {
      return Object.values(this.run.sections).length > 1
    },
    total () {
      let parts = Object.values(this.run.sections).flat()
      return parts.map((ob) => parseFloat(ob.length)).reduce((partial, a) => partial + a , 0)
    },
    feet () {
      return this.MetricToFeet(this.total)
    },
    firstEndCap() {
      let item = this.getPart(1, 0)
      return this.isEndCap(item) ? this.getEndCapWidth(item) : '0'
    },
    lastEndCap() {
      let section = this.hasManySections ? 2: 1
      let index = this.run.sections[section].length - 1
      let item = this.getPart(section, index)
      return this.isEndCap(item) ? this.getEndCapWidth(item) : '0'
    },
    longerSection () {
      if ( ! this.hasManySections) {
        return 1
      }

      return this.getChannelsOfSection(1).length > this.getChannelsOfSection(2).length ? 1 : 2
    },
    depths() {
      let depths = this.getChannelsOfSection(this.longerSection).map((el) =>  el.depth).sort()
      return [ ...new Set(depths)]
    },
  },
  methods: {
    getLength(parts) {
      return parts.map((ob) => parseFloat(ob.length)).reduce((partial, a) => partial + a , 0)
    },
    setWidth(parts) {
      let length  = this.getLength(parts)
      let percent = Math.round(length * 100 / this.total)

      return `${percent}%`
    },
    getPart(section, index) {
      return this.run.sections[section][index]
    },
    isEndCap(part) {
      let accesories = [ 'ec', 'ce']
      return part.part_type == 'accessory' && accesories.includes(part.type)
    },
    getEndCapWidth({outlet_size}){
      if (outlet_size) {
        return '40px'
      }
      return '25px'
    },
    toRightFlow (section){
      return this.run.outlet == this.outlets.End || this.run.outlet == this.outlets.Central && section == 1 || this.run.outlet == this.outlets.DoubleEnd && section == 2
    },
    getChannelsOfSection(section) {
      return this.run?.sections[section].filter(el => el.part_type == 'channel' )
    },
  },
}
</script>

<style>
.drawing-section { width: 100%;}
@media (min-width: 640px) {
  .drawing-section {width: var(--width);}
}
</style>
